module.exports = __webpack_public_path__ + "media/images/pc/stores/fukuoka/fukuoka_concept_01-9724beb6e1eb884b0b5835dc80026339.jpg";